export class UserPermission {
  permissions?: {
    key: string
    name: string
    description: string
    requiredPermissions: string[],
    serviceKey: string
  }[]
  services?: {
    key: string
    name: string
    description: string
    isEnable: boolean
  }[]
}
